import React from "react";
import ExperienceCard from "../../base/card/experienceCard";

const Experiences = ({
  experiences,
  gviExperiencesLabel,
  gviExperiencesDescription,
  expTabSubtitle
}) => {
  return (
    <>
      <div className="gvi-experiences">
        <h2
          className="heading text-left py-5 leading-6 sm:leading-[38px]"
          dangerouslySetInnerHTML={{
            __html: gviExperiencesLabel
          }}
        />
        <div className="sub-heading text-xs text-black-lighter planet:text-gray-generic mb-2 pl-2 border-l-[2px] border-l-red-light planet:border-l-green-standard">
          {expTabSubtitle}
        </div>

        <div className="divide-y width-divider" />

        <div className="tab-content-description planet:gvi-light-gray-text text-black-lighter text-sm pt-8 pb-5">
          <div
            className="tab-content_html"
            dangerouslySetInnerHTML={{
              __html: gviExperiencesDescription
            }}
          />
        </div>

        <div className="tab-content-body">
          <div className="grid grid-cols-2 gap-4">
            {experiences?.map((experience, index) => {
              const experienceTitle = experience.experienceTitle;
              const experienceFeaturedImage = experience
                ?.experienceFeaturedImage?.localFile
                ? experience?.experienceFeaturedImage?.localFile
                : experience?.experienceFeaturedImage?.sourceUrl;
              const experienceDescription = experience?.experienceOneliner;
              return (
                <ExperienceCard
                  bgImage={experienceFeaturedImage}
                  fallbackImage={experienceFeaturedImage}
                  experienceTitle={experienceTitle}
                  experienceDescription={experienceDescription}
                  isRounded={true}
                  isRoundedTop={false}
                  key={`exp-card-${index}`}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Experiences;
